import {runInAction} from 'mobx';

import {api} from '../../ApiFacade';
import {FlatListForLogGenericState, FlatListGroup} from '../../components/flats/FlatListForLogGenericState';
import {showCommunicationError} from '../../helpers/alerts';
import {showLoaderAsync} from '../../helpers/loaders';
import {FlatListDto, LogOverviewDtoGenericApiResponse} from '../../swagger';
import {AppRoutes, assignedLink} from '../../routing/AppRoutes';
import {setTitle} from '../../routing/AppRouting';

export class AssignedViewState extends FlatListForLogGenericState {
    route = AppRoutes.Assigned;

    constructor() {
        super();
        this.showSearch = false;
    }

    loadList(): Promise<void> {
        this.listParams.logId = FlatListGroup.assigned;
        return showLoaderAsync(api().flats.apiFlatsAssignedGet(this.listParams))
            .then((res: LogOverviewDtoGenericApiResponse) => {
                if (res.content?.items && res.content?.items.length > 0 && this.currentFlatId === undefined) {
                    this.loadFlat(res.content?.items[0]);
                }

                if (this.currentFlatId) {
                    const flat = res.content?.items?.find((x) => x.flatId === this.currentFlatId);
                    if (flat) {
                        this.loadFlat(flat);
                    }
                }

                setTitle('Assigned');

                runInAction(() => {
                    this.log = res.content;
                });
            })
            .catch((err) => showCommunicationError(err));
    }

    flatLoadUrlHandler(flat: FlatListDto) {
        if (!this.flat) {
            return;
        }
        // eslint-disable-next-line no-restricted-globals
        if (!location.pathname.includes(this.flat.flatId!)) {
            // eslint-disable-next-line no-restricted-globals
            window.history.replaceState({}, 'Muscula', assignedLink(this.flat.flatId!));
        }
    }

    search(): void {
        throw new Error('Method not implemented.');
    }

    delete(): void {
        throw new Error('Method not implemented.');
    }
}
